import { render, staticRenderFns } from "./affiliate-question-bundle.view.vue?vue&type=template&id=09504b4e&scoped=true&"
import script from "./affiliate-question-bundle.view.vue?vue&type=script&lang=ts&"
export * from "./affiliate-question-bundle.view.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-question-bundle.view.vue?vue&type=style&index=0&id=09504b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09504b4e",
  null
  
)

export default component.exports